import { Component, Input, OnChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgStyle } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

export interface CardValue {
  year: string;
  value: string;
  unit: string;
  routerLink: string;
}

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  imports: [RouterLink, NgStyle, IconComponent],
})
export class CardComponent implements OnChanges {
  @Input({ required: true }) public icon?: string;
  @Input({ required: true }) public color?: string;
  @Input({ required: true }) public title?: string;
  @Input({ required: true }) public values?: CardValue[];

  public currentCardValue: CardValue | undefined;
  public currentCardValueIndex: number = 0;

  public ngOnChanges(): void {
    this.currentCardValue = this.values?.[0];
  }

  public changeCardValue(event: Event, value: CardValue): void {
    event.preventDefault();
    event.stopPropagation();
    this.currentCardValue = value;
    this.currentCardValueIndex = this.values?.indexOf(value) ?? 0;
  }
}
